import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import ModalWrapper from "../../../layouts/ModalWrapper.jsx";
import { convertToUTCFormat, formatAmount } from "../../../utils/format.js";
import { modalEventListener } from "../../../utils/ModalEventListener";

const TranchePaymentDetailsModal = ({
  closeTrancheDetailsModal,
  caseDetails,
  showTrancheDetailsModal,
}) => {
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeTrancheDetailsModal);
  }, [closeTrancheDetailsModal]);

  const getTrancheDisAmount = (payment) => {
    let disbursed_amount = "";
    if (
      [10, 11].includes(payment.sub_stage) &&
      payment.money_returned_to_bank
    ) {
      disbursed_amount = payment.money_returned_to_bank;
    } else if (
      payment.release_foreclosure_amount &&
      payment.total_foreclosure_amount
    ) {
      disbursed_amount = payment.total_foreclosure_amount;
    } else {
      disbursed_amount = payment.disburse_paid_amt;
    }
    return disbursed_amount;
  };

  return ReactDOM.createPortal(
    <ModalWrapper
      show={showTrancheDetailsModal}
      onClose={closeTrancheDetailsModal}
    >
      <div className="modal-wrapper">
        <div className="tranchedetail-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              onClick={closeTrancheDetailsModal}
            >
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              Tranche Payment
            </h4>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table table-striped jambo_table bulk_action">
                <thead>
                  <tr className="headings">
                    <th className="column-title">Amount </th>
                    <th className="column-title">Date</th>
                    <th className="column-title">Maker</th>
                    <th className="column-title">Released By</th>
                    <th className="column-title">UTR</th>
                    <th className="column-title">Tranche </th>
                  </tr>
                </thead>

                <tbody>
                  {caseDetails?.paymentDetails?.length > 0 &&
                    caseDetails.paymentDetails.map((payment, index) => {
                      let hodName = "";
                      if (
                        [8, 9, 10, 11].includes(+caseDetails.sub_stage) &&
                        payment.hod_name &&
                        payment.pay_count === caseDetails.dts_pay_count &&
                        caseDetails.is_reassigned === 0
                      ) {
                        hodName = payment.hod_name;
                      } else if (
                        caseDetails.dts_pay_count > payment.pay_count
                      ) {
                        hodName = payment.hod_name;
                      } else if (
                        payment.pay_count === caseDetails.dts_pay_count &&
                        caseDetails.is_reassigned === 1
                      ) {
                        hodName = payment.hod_name;
                      } else {
                        hodName = "--";
                      }

                      const directPayment =
                        payment?.payable_ac_number?.trim() === "Direct Payment"
                          ? " (Direct Payment) "
                          : "";
                      const releasedAmt = getTrancheDisAmount(payment);

                      let releasedDate = payment.released_date
                        ? convertToUTCFormat(
                            new Date(payment.released_date),
                            "yyyy-MM-dd HH:mm:ss"
                          )
                        : "--";

                      releasedDate =
                        releasedDate !== "0000-00-00 00:00:00"
                          ? releasedDate
                          : "--";
                      return (
                        <tr className="even pointer" key={index}>
                          <td>
                            {formatAmount(releasedAmt)}
                            {directPayment}
                          </td>

                          <td>{releasedDate}</td>
                          <td>{payment?.maker_name}</td>
                          <td>{hodName}</td>
                          <td>{payment?.payable_rtgs_cheque_number}</td>
                          <td>Payment {payment.pay_count}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={closeTrancheDetailsModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default TranchePaymentDetailsModal;
